import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

class Input extends PureComponent {

  /**
   * Hack to prevent scrolling on the inputs triggering the stepper
   * @param e
   */
  numberInputOnWheelPreventChange = (e) => {
    e.target.blur()
  }

  render () {
    const classNames = ['InputText']
    let label
    if (this.props.label !== undefined) {
      let labelAppend = null
      if (this.props.labelAppend) {
        labelAppend = <span className={'input-label-append'}>{this.props.labelAppend}</span>
      }
      label = <label>{this.props.label + (this.props.required ? ' *' : '')}{labelAppend}</label>
    }

    let message
    if (this.props.valid !== true) {
      if (this.props.message) {
        message = <span>{this.props.message}</span>
      }
      classNames.push('InputTextError')
    }
    if (this.props.indicateNativeInvalidState) {
      classNames.push('IndicateNativeInvalidState')
    }

    return (
      <div className={classNames.join(' ')}>
        {label}
        <input
          type={this.props.type}
          name={this.props.name}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          required={this.props.required}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          onFocus={this.props.onFocus}
          value={this.props.value}
          min={this.props.min}
          step={this.props.step}
          onWheel={this.props.type === 'number' ? this.numberInputOnWheelPreventChange : undefined}
        />
        {message}
      </div>
    )
  }
}

Input.defaultProps = {
  type: 'text',
  placeholder: '',
  disabled: false,
  required: false,
  valid: true,
  indicateNativeInvalidState: false,
}

Input.propTypes = {
  indicateNativeInvalidState: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  labelAppend: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  valid: PropTypes.bool,
  message: PropTypes.string,
  name: PropTypes.string,
  min: PropTypes.number,
  step: PropTypes.number,
}

export default Input
